import ActionKeys from '../actions/ActionKeys';

const initialState = {
    detail: null,
    getDataTypeTicket: {
        adjustType: null,
        qrKeySearch: '',
    },
};

export const adjustmentTicketReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionKeys.ADJUSTMENT_TICKET.GET_DETAIL:
            return {
                ...state,
                detail: action.data,
            };
        case ActionKeys.ADJUSTMENT_TICKET.GET_DATA_TYPE_TICKET:
            return {
                ...state,
                getDataTypeTicket: action.data,
            };
        default:
            return state;
    }
};
